module.exports = "<div ng-include=\"&quot;directories/templates/sort-filters.html&quot;\"></div>";